import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { getDataState } from './item.gts';
import type { AccordionContentExternalSignature } from './public.ts';
interface Signature extends AccordionContentExternalSignature {
    Args: AccordionContentExternalSignature['Args'] & {
        isExpanded: boolean;
        value: string;
        disabled?: boolean;
    };
}
export class AccordionContent extends Component<Signature> {
    static{
        template(`
    <div
      role="region"
      id={{@value}}
      data-state={{getDataState @isExpanded}}
      hidden={{this.isHidden}}
      data-disabled={{@disabled}}
      ...attributes
    >
      {{yield}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    get isHidden() {
        return !this.args.isExpanded;
    }
}
export default AccordionContent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2VtYmVyLXByaW1pdGl2ZXMvZW1iZXItcHJpbWl0aXZlcy9lbWJlci1wcmltaXRpdmVzL3NyYy9jb21wb25lbnRzL2FjY29yZGlvbi9jb250ZW50Lmd0cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5cbmltcG9ydCB7IGdldERhdGFTdGF0ZSB9IGZyb20gJy4vaXRlbS5ndHMnO1xuXG5pbXBvcnQgdHlwZSB7IEFjY29yZGlvbkNvbnRlbnRFeHRlcm5hbFNpZ25hdHVyZSB9IGZyb20gJy4vcHVibGljLnRzJztcblxuaW50ZXJmYWNlIFNpZ25hdHVyZSBleHRlbmRzIEFjY29yZGlvbkNvbnRlbnRFeHRlcm5hbFNpZ25hdHVyZSB7XG4gIEFyZ3M6IEFjY29yZGlvbkNvbnRlbnRFeHRlcm5hbFNpZ25hdHVyZVsnQXJncyddICYge1xuICAgIGlzRXhwYW5kZWQ6IGJvb2xlYW47XG4gICAgdmFsdWU6IHN0cmluZztcbiAgICBkaXNhYmxlZD86IGJvb2xlYW47XG4gIH07XG59XG5cbmV4cG9ydCBjbGFzcyBBY2NvcmRpb25Db250ZW50IGV4dGVuZHMgQ29tcG9uZW50PFNpZ25hdHVyZT4ge1xuICA8dGVtcGxhdGU-XG4gICAgPGRpdlxuICAgICAgcm9sZT1cInJlZ2lvblwiXG4gICAgICBpZD17e0B2YWx1ZX19XG4gICAgICBkYXRhLXN0YXRlPXt7Z2V0RGF0YVN0YXRlIEBpc0V4cGFuZGVkfX1cbiAgICAgIGhpZGRlbj17e3RoaXMuaXNIaWRkZW59fVxuICAgICAgZGF0YS1kaXNhYmxlZD17e0BkaXNhYmxlZH19XG4gICAgICAuLi5hdHRyaWJ1dGVzXG4gICAgPlxuICAgICAge3t5aWVsZH19XG4gICAgPC9kaXY-XG4gIDwvdGVtcGxhdGU-XG5cbiAgZ2V0IGlzSGlkZGVuKCkge1xuICAgIHJldHVybiAhdGhpcy5hcmdzLmlzRXhwYW5kZWQ7XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgQWNjb3JkaW9uQ29udGVudDtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQyxTQUFTLFlBQVksUUFBUSxhQUFhO0FBRTFDLGNBQWMsaUNBQWlDLFFBQVEsY0FBYztVQUUzRCxrQkFBa0I7SUFDMUIsTUFBTSxrQ0FBa0M7UUFDdEMsWUFBWSxPQUFPO1FBQ25CLE9BQU8sTUFBTTtRQUNiLFdBQVcsT0FBTzs7O0FBSXRCLE9BQU8sTUFBTSx5QkFBeUIsVUFBVTtJQUM5QyxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7Ozs7Ozs7OztFQVdWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQVhBO0lBYVYsSUFBSSxXQUFXO1FBQ2IsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVTtJQUM5QjtBQUNGO0FBRUEsZUFBZSxpQkFBaUIifQ